import { Box, Modal } from "@mui/material";
import OrangeButton from "../../../../components/buttons/OrangeButton";
import { useState } from "react";
import { useConvertLeavePlanToLeaveRequest } from "../../../../services/leave-request.service";
import useEditFormStore from "../../../../state-management/useEditFormStore";
import { useViewPort } from "../../../../helpers/useViewPort";
import { useManageTableWithSearchParamsData } from "../../../../helpers/useManageTable";

const ConvertPlanModal = ({
	openConvertPlan,
	setOpenConvertPlan,
}) => {
	const viewPortWidth = useViewPort();
	const { formDataValues } = useEditFormStore();
	const [converting, setConverting] = useState(false);
	
	const { mutate: convertPlanToRequest } = useConvertLeavePlanToLeaveRequest();
	const { reloadTableData } = useManageTableWithSearchParamsData();

	const handleConvertPlan = () => {
		setConverting(true);

		convertPlanToRequest(
			{ payload: { leavePlanId: formDataValues?.id } },
			{
				onSuccess: () => {
					reloadTableData({ refreshSummary: "true" });
					setOpenConvertPlan(false);
				},
				onSettled: () => setConverting(false),
			}
		);
	};

	return (
		<Modal open={openConvertPlan}>
			<Box sx={{
				position: "absolute" as "absolute",
				top: "50%",
				left: "50%",
				transform: "translate(-50%, -50%)",
				width: viewPortWidth < 1024 ? "92%" : 450,
				py: 4,
				bgcolor: "background.paper",
				boxShadow: 24,
				border: "none",
				borderRadius: "8px",
				outline: "none",
				overflow: "auto",
				maxHeight: "95vh",
				display: "flex",
				flexDirection: "column",
			}}>
				<div className="w-full px-6 lg:px-8">
					<div className="flex justify-center">
						<h3 className="text-xl font-bold">Convert Leave Plan</h3>
					</div>
					<div className="mt-6">
						<p className="text-2sm text-center">
							Do you want to convert this leave plan
							<br className="max-lg:hidden" /> 
							{" "}into a leave request?
						</p>
					</div>
					<div className="max-lg:w-full mt-8 flex justify-center space-x-4 whitespace-nowrap text-center">
						<button
							title={"Cancel"}
							onClick={() => setOpenConvertPlan(false)}
							className={`lg:px-14 max-lg:w-full text-gray-400 bg-white border rounded-lg
								border-secondary-lightgray text-2xs ${converting && "opacity-50"}
							`}
							disabled={converting}
						>
							Cancel
						</button>
						<OrangeButton
							onClick={handleConvertPlan}
							title={converting ? "Converting..." : "Yes, Convert"}
							className={"lg:px-10 max-lg:w-full"}
							disabled={converting}
						/>
					</div>
				</div>
			</Box>
		</Modal>
	);
};

export default ConvertPlanModal;

